module.exports = __webpack_public_path__ + "fontawesome-webfont.25a32416abee198dd821.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 551
// module chunks = 1